import script from "./SpeakerList.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakerList.vue?vue&type=script&setup=true&lang=js"

import "./SpeakerList.vue?vue&type=style&index=0&id=25d8ff27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d8ff27"]])

export default __exports__